import { aboutContent } from '@/mocks/homepage';

export default function AboutSection() {
  return (
    <section id="about" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-black text-foreground-900 mb-4 md:mb-5">{aboutContent.title}</h2>
        <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-2xl mx-auto">{aboutContent.content}</p>
        <div className="flex flex-wrap items-center justify-center gap-3 mt-5 md:mt-6">
          <span className="flex items-center gap-1.5 text-sm text-foreground-600">
            <i className="ri-checkbox-circle-fill text-primary-500"></i> 火辣但不露骨
          </span>
          <span className="flex items-center gap-1.5 text-sm text-foreground-600">
            <i className="ri-checkbox-circle-fill text-primary-500"></i> 800 万+ 活跃用户
          </span>
          <span className="flex items-center gap-1.5 text-sm text-foreground-600">
            <i className="ri-checkbox-circle-fill text-primary-500"></i> 每日更新 200+ 内容
          </span>
        </div>
      </div>
    </section>
  );
}